import { onError } from '@apollo/client/link/error'
import VueCookies from "vue-cookies";

export function useApolloErrorLink(){

    const getApolloErrorLink = (router) => {

        return onError(({ graphQLErrors, networkError, operation }) => {
            if (graphQLErrors) {

                const filtered = graphQLErrors?.filter(err => {
                    return !err.extensions?.validation
                        && !err.extensions?.validationErrors
                        && err.extensions?.category !== 'tamepulse_assistant'
                }) ?? []

                if (filtered.length > 0) {
                    const hasUnauthenticated = filtered.some(err => err.message === 'Unauthenticated.' || err.message === 'This action is unauthorized.')

                    if (hasUnauthenticated) {

                        if(router){

                            VueCookies.remove('admin_token')

                            router.push({ name: 'login', query: { redirect: router.currentRoute.value.fullPath } })
                        }

                    } else if (!operation?.getContext?.()?.suppressGlobalErrorAlert) {
                        alert("We apologize, but an error has occurred.")
                    }
                }

                graphQLErrors.forEach((err) => {

                    console.log(err)

                    if (filtered.length > 0) {
                        console.error(`[GraphQL error]:`, err)
                    }

                })
            }

            if (networkError) {

                if(networkError?.name === 'AbortError') return

                if (networkError.statusCode === 403 || networkError.statusCode === 401) {
                    if (router) {
                        VueCookies.remove('admin_token')
                        router.push({ name: 'login', query: { redirect: router.currentRoute.value.fullPath } })
                    }
                    return
                }

                console.error(`[Network error]:`, networkError)
            }
        })

    }

    return {
        getApolloErrorLink
    }
}
